import { AttendanceStatus } from "@prisma/client";

export const ATTENDANCE_STATUSES = [
    AttendanceStatus.ATTENDING,
    AttendanceStatus.PROCESSING,
    AttendanceStatus.MAYBE,
    AttendanceStatus.NOT_ATTENDING,
    AttendanceStatus.PENDING_APPROVAL,
    AttendanceStatus.WAITLIST,
];
